module.exports = __webpack_public_path__ + "img/GPB_Top10_2019.f1578c5d.png";